import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { ChecklistsModuleIcon, CircleIcon } from '@csrc/assets/icons'
import { isProduction } from "@utils"

export const checkListNavigation = [
  {
    id: 'chk.checklist',
    title: 'checklist.nav.checklists',
    icon: <FontAwesomeIcon icon={ChecklistsModuleIcon} />,
    // navLink: '/checklist/templates',
    children: [
      {
        id: 'chk.checklist.list',
        title: 'checklist.nav.checklists',
        icon: <FontAwesomeIcon icon={CircleIcon} />,
        navLink: '/checklist/templates',
        action: 'call',
        resource: 'CKL_MANAGE_TEMPLATES'
      },
      {
        id: 'chk.checklist.globalItems',
        title: 'checklist.nav.globalItems',
        icon: <FontAwesomeIcon icon={CircleIcon} />,
        navLink: '/checklist/global-items',
        action: 'call',
        resource: 'CKL_MANAGE_TEMPLATES',
        featureKey: 'ckl_global_item'
        // omit: isProduction()
      },
      {
        id: 'chk.checklist.yesno',
        title: 'checklist.nav.globalResponses',
        icon: <FontAwesomeIcon icon={CircleIcon} />,
        navLink: '/checklist/global-response/list',
        action: 'call',
        resource: 'CKL_MANAGE_TEMPLATES'
      },
      {
        id: 'chk.checklist.publicLibrary',
        title: 'checklist.nav.publicLibraries',
        icon: <FontAwesomeIcon icon={CircleIcon} />,
        navLink: '/checklist/library',
        action: 'call',
        resource: 'CKL_MANAGE_TEMPLATES',
        badge: 'light-info',
        badgeText: 'general.new'
      }
    ]
  }
]
